import React from 'react';
import { Link } from 'react-router-dom';

const SingleItem = ({ data, index, handleEnableDisabled, paginateData, handleDelete }) => {
    return (
        <>
            <tr>
                <td data-label="S.N.">
                    {parseFloat(index + 1) +
                        parseFloat(paginateData?.page) * parseFloat(paginateData?.limit) -
                        10}
                </td>
                <td data-label="QR Code">
                    <div className="user">
                        <div className="thumb">
                            <img src={`https://api.velormall.com/${data?.QRCode}`} alt="" />
                        </div>
                    </div>
                </td>
                <td data-label="Network">{data?.network}</td>
                <td data-label="Status">
                    {data?.status ? (
                        <span class="badge badge--success text-success">Enabled</span>
                    ) : (
                        <span>
                            <span class="badge badge--warning text-warning">Disabled</span>
                        </span>
                    )}
                </td>
                <td data-label="Action">
                    <Link to={`/admin/deposit/method/edit/${data?._id}`} class="btn btn-sm btn-outline-primary"><i class="la la-pencil-alt"></i> Edit</Link>
                    {data?.status ? (
                        <button
                            onClick={() => handleEnableDisabled(data?._id)}
                            class="btn btn-sm btn-outline-danger confirmationBtn"
                        >
                            <i class="la la-eye-slash"></i> Disable
                        </button>
                    ) : (
                        <button
                            onClick={() => handleEnableDisabled(data?._id)}
                            class="btn btn-sm btn-outline-success confirmationBtn"
                        >
                            <i class="la la-eye"></i> Enable
                        </button>
                    )}
                    <button class="btn btn-sm btn-outline-danger " onClick={() => handleDelete(data?._id)} ><i class="la la-trash"></i> Remove</button>
                </td>
            </tr>
        </>
    );
};

export default SingleItem;